export default {
  prr: 'HMD',
  rap: 'RAP',
  coachingNotes: 'coachingNotes',
};
